export default __webpack_public_path__ + "static/media/Ekierka-06.cc252372.svg";